export default __webpack_public_path__ + "static/media/330_dummy2016-reiseblog01-de.8bb144b3.png";